module.exports = __webpack_public_path__ + "img/logo.b78b79c3.png";